var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNpd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.49 59.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #805aed;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n        stroke-width: 1.5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.79,58.75H8.47v-18.12C3.73,36.43.75,30.38.75,23.66.75,11,11.27.75,24.24.75s23.47,10.25,23.47,22.91c0,.87-.05,1.74-.15,2.6-.05.43.03.86.24,1.23l4.71,8.26c.57.98,0,2.21-1.1,2.45l-4.84,1v7.84c0,1.35-1.1,2.45-2.47,2.45h-10.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.52,45.09l1.68,1.67c1.74,1.74,4.11,2.72,6.58,2.72"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "35.8 49.48 35.8 58.75 32.64 58.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.07,4.53s3.45.35,6.07,4.76-.96,7.73.61,9.52c1.57,1.79,3.8-.74,2.62-4.23,0,0,4.5,2.66,4.5,10.26s-6.59,10.56-12.83,10.83c-7.69.32-14.84-2.84-14.84-10.04s3.97-10.17,3.97-10.17c0,0-.85,4.98,2.6,4.43,2.13-.34.24-2.92.03-5.43-.34-4.11,3.74-5.59,3.74-5.59,0,0-.93,4.21,2.67,4.21,3.26,0,2.71-5.94.86-8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.62,30.08c0,3.08-2.5,5.59-5.59,5.59s-5.59-2.5-5.59-5.59,5.59-9.14,5.59-9.14c0,0,5.59,6.05,5.59,9.14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNpd);
export default __webpack_public_path__ + "static/media/NPD.9c44ac8d1e1d1f78b6bc061495699f24.svg";
export { ForwardRef as ReactComponent };